import React, { SyntheticEvent, useEffect, useRef } from "react";

import { useDispatch, useSelector, DefaultRootState } from "react-redux";
import { changeUserCartId, setUserInfo } from "../../../../appRedux/actions/User";
import { Dropdown, Button, Divider, Modal, Spin } from "../../../BP2Components";
import { setBackUrl, userSignOut } from "../../../../appRedux/actions/Auth";
import { fetchAllUsersIfNeeded } from "../../../../appRedux/actions/Messages";
import { getCurrentClientTypeId, getVisibleSystemButtons } from "../../FormV2Scripts";
import { useMessageItem } from "../../../../context/MessageItemContext/MessageItemContext";
import { FORM_SUBMIT_ERROR, FormSubmitError } from "../../../../context/FormContext/FormContext";
import { setUserBoards } from "../../../../appRedux/actions/Boards";
import { Link, useHistory } from "react-router-dom";
import { clearCart } from "../../../../appRedux/actions/Cart";
import { useFormV3 } from "../../../../context/FormV3Context/FormV3Context";
import { setUrlTo, isInNuxtContext } from "../../GeneralScripts";
import { useState } from "react";
import { Message } from "../../../BP2Components";
import { useIntl } from "react-intl";
import {
   getUserData,
   getUserWithBoards,
   getUsers,
   handleSysButton,
} from "../../../../services/restAPI/RestApi";

import SingleButton from "../NormalButtons/SingleButton";
import SingleSysButton from "../SystemButtons/SingleSysButton";
import CreateChatInMessage from "../../../Widgets/WidgetsSettings/ChatSettings/CreateChatInMessage";
import IntlMessages from "../../../../util/IntlMessages";
import projectConfig from "../../../../projectConfig.json";

import "./MessageButtonsDropdown.less";

import FormComplete from "../../FormComplete";
import { useCheckIfButtonDisabled } from "../../../../util/useCheckIfButtonDisabled";
import {
   useFastActionsContext,
   useFormState,
} from "../../../Widgets/InfiniteListWidget/FastActionsContext/FastActionContext";
import { ActionButton } from "../../../Widgets/InfiniteListWidget/FastActionsContext/types";
import { LinkToCase } from "../../CasesList/SingleCase/LinkToCase/LinkToCase";
import MessageModal from "../Modals/MessageModal";
import { persistor } from "../../../../appRedux/store/Store";

const MessageButtonsDropdown = ({
   normalButtons,
   systemButtons,
   windowWidth,
   sysBtnsConfig,
   currentProcessStep,
   setCurrentProcessStep,
   isQuestionMode,
   btnClassName = "",
   inCaseActions = false,
   buttonAsLink = false,
   actionCallback,
   displayedInInfinityList = false,
   infinityListActions,
   isLoadingActions = false,
   isSingleCaseItem = false,
   linkToCase,
   hideChat = false,
}) => {
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const dropdownTriggerRef = useRef<HTMLSpanElement>(null);
   const autoTriggerFiredRef = useRef<boolean>(false);
   const actionId = currentProcessStep?.planningData?.id ?? "";

   const {
      setActions,
      setModalStep,
      modalStep,
      actions,
      setTabsVisibility,
      isFormLoading,
      hasRequiredFields,
      setHasRequiredFields,
   } = useFastActionsContext();
   const { isFormOpen, setIsFormOpen } = useFormState();
   const [isRecipientFormOpen, setIsRecipientFormOpen] = useState<boolean>(false);
   const [isExecutingAction, setIsExecutingAction] = useState(false);

   const { formInfo, backUrl } = useSelector((state: DefaultRootState) => state.formsv2);
   const { carts, mainPageUrl, departments, currentDepartmentId }: any = useSelector(
      (state: DefaultRootState) => state.user,
   );
   const postStepRedirectUrl = backUrl || mainPageUrl || "/cases/new";

   const visibilityOptions = useSelector((state: DefaultRootState) => state.visibilityOptions);

   const { goToTheNextProcessStep } = useFormV3();
   const {
      formUuid,
      refreshForm,
      formRef,
      isAnyFieldInFormLoading,
      setIsAnyFieldInFormLoading,
      setTriggerRequiredFieldsModal,
      setPendingAction,
      missingCheckboxSelections,
   } = useMessageItem();
   const isButtonsDisabled =
      isAnyFieldInFormLoading || isExecutingAction || missingCheckboxSelections.size > 0;

   const intl = useIntl();
   const history = useHistory();
   const dispatch = useDispatch();

   const query = new URLSearchParams(window.location.search);
   const processIdFromUrl = query.get("processId");
   const plannedDate = currentProcessStep?.planningData?.start_time ?? "";
   const instanceId = currentProcessStep?.instanceId;
   const formId = currentProcessStep?.formId;
   const recordId = currentProcessStep?.recordId
      ? currentProcessStep?.recordId
      : currentProcessStep?.dataId;

   const checkIfDisabled = useCheckIfButtonDisabled();

   const { allUsersLoaded, allUsersLoading } = useSelector(({ messages }) => messages);

   const currentClientTypeId = getCurrentClientTypeId(departments, currentDepartmentId);

   const visibleSystemButtons = getVisibleSystemButtons({
      systemButtons,
      visibilityOptions,
      clientTypeId: currentClientTypeId,
   });

   const handleNormalAction =
      (action, messageModalFormRef, stepId, recipientId, closeModal, isUserNextStepRecipient) =>
      async (event) => {
         event.preventDefault();

         if (!formUuid) return;

         setTriggerRequiredFieldsModal(true);
         // Sometimes this function is used wihtout messageModalFormRef
         if (!!messageModalFormRef) {
            let isError = false;
            // First we need to check if user selected recipient etc.
            messageModalFormRef.validateFields((err) => {
               if (err) isError = true;
            });
            if (isError) return;
         }
         if (action) {
            let comment: string | undefined;
            let selectedRecipient: string | undefined;
            if (!!messageModalFormRef) {
               comment = messageModalFormRef.getFieldValue("comment");
               selectedRecipient = messageModalFormRef.getFieldValue("selectRecipient");
            }
            setIsExecutingAction(true);
            Message.loading(intl.formatMessage({ id: "form.isProcessing" }));
            // If there is no formRef then it's formV3
            const isFormV3 = !formRef?.current?.goToTheNextProcessStep;
            const goToTheNextStep =
               formRef?.current?.goToTheNextProcessStep || goToTheNextProcessStep;

            goToTheNextStep(
               action.actionId,
               comment,
               recipientId ?? selectedRecipient,
               stepId,
               isFormV3 ? recordId : undefined,
            )
               .then((res) => {
                  // If the current process step has "refreshOnCloud === '1'", we need to call getWithBoards() after moving to the next step.
                  // This handles cases where data needs to be refreshed after progressing to the next step.
                  // The process works as follows:
                  // 1. Modify data in the form.
                  // 2. Save the updated data to the backend using goToNextStep().
                  // 3. Refresh the data by fetching the latest version with getWithBoards.
                  if (currentProcessStep?.configuration?.refreshOnCloud === "1") {
                     getUserWithBoards().then((res) => {
                        const { boards, ...userData } = res.data;
                        dispatch(setUserInfo(userData));
                        dispatch(setUserBoards(boards));
                        dispatch(setBackUrl(""));
                        setIsOpen(false);
                        persistor.flush().then(() => {
                           setUrlTo(userData.mainPageUrl || backUrl || "/cases/new");
                        });
                     });
                  }
                  const actionResp = res?.data?.action;
                  if ((Array.isArray(actionResp) && actionResp.length === 0) || res?.data === "") {
                     // End of delete account process
                     if (
                        processIdFromUrl &&
                        projectConfig?.deleteAccountProcessId === +processIdFromUrl
                     ) {
                        dispatch(userSignOut());
                        Message.destroy();
                        Message.success(
                           intl.formatMessage({ id: "process.accountHasBeenRemoved" }),
                        );
                        window.location.assign("/signin");
                        return;
                     }

                     const shopConfig = projectConfig?.shop as {
                        shopId: string;
                        orderProcessId: number;
                     } | null;

                     // End of order process
                     if (processIdFromUrl && shopConfig?.orderProcessId === +processIdFromUrl) {
                        getUserData()
                           .then((response) => {
                              if (response?.data?.carts) {
                                 const previousMultimodusCart = carts.find(
                                    (cart) => cart.shopId === shopConfig?.shopId,
                                 );
                                 const currentMultimodusCart = response.data.carts.find(
                                    (cart) => cart.shopId === shopConfig?.shopId,
                                 );
                                 if (currentMultimodusCart?.id !== previousMultimodusCart?.id) {
                                    dispatch(clearCart(shopConfig?.shopId));
                                    dispatch(
                                       changeUserCartId(
                                          shopConfig?.shopId,
                                          currentMultimodusCart.id,
                                       ),
                                    );
                                 }
                              }
                              Message.destroy();
                              Message.success(intl.formatMessage({ id: "form.doneProcessing" }));
                              setUrlTo(postStepRedirectUrl);
                              return;
                           })
                           .catch((err) => {
                              Message.destroy();
                              Message.error(intl.formatMessage({ id: "form.errorWhileSaving" }));
                              return;
                           });
                     }
                     //Normal end of process / process that goes to another person
                     if (currentProcessStep?.configuration?.refreshOnCloud !== "1") {
                        dispatch(setBackUrl(""));
                        setIsOpen(false);
                        return persistor.flush().then(() => {
                           setUrlTo(postStepRedirectUrl);
                           Message.destroy();
                           Message.success(intl.formatMessage({ id: "form.doneProcessing" }));
                        });
                     }
                     return;
                  } else {
                     //Default action, where the next reciver of process is a user logged-in
                     setCurrentProcessStep(res?.data?.action);
                     closeModal && closeModal();
                     Message.destroy();
                     Message.success(intl.formatMessage({ id: "form.doneProcessing" }));
                     return res?.data?.action;
                  }
               })
               .then((res) => {
                  if (isUserNextStepRecipient) {
                     setHasRequiredFields(true);
                     setModalStep(res);
                     setActions(Array.isArray(res.actions) ? res.actions : [res.actions]);
                     actionCallback && actionCallback();
                  }
                  refreshForm && refreshForm();
               })
               .catch((err) => {
                  if (err?.response?.data?.message === "system.api.security.user_logged_out") {
                     Message.success(intl.formatMessage({ id: "form.loggingOutMessage" }), 5000);
                     Message.destroy();
                     closeModal && closeModal();
                     setTimeout(() => {
                        history.push("/signin");
                     }, 5000);
                  } else {
                     console.log(JSON.stringify(err));
                     Message.destroy();
                     Message.error(intl.formatMessage({ id: "form.errorWhileSaving" }));
                     closeModal && closeModal();
                  }
               })
               .finally(() => setIsExecutingAction(false));
         }
      };

   const handleSysAction = (sysAction, sysModalFormRef, closeModal) => async (event) => {
      //@ts-ignore
      window.sysAction = sysAction?.name;
      event.preventDefault();

      const selectedRecipient = sysModalFormRef.getFieldValue("selectRecipient");

      if (inCaseActions) {
         if (!!selectedRecipient) {
            setIsExecutingAction(true);
            Message.loading(intl.formatMessage({ id: "form.isProcessing" }));

            let comment = sysModalFormRef.getFieldValue("comment");

            handleSysButton(
               sysAction.data.method,
               sysAction.data.action,
               Number(sysAction.data.body.messageId),
               Number(sysAction.data.body.instanceStepId),
               Number(selectedRecipient),
               comment,
            )
               .then(() => {
                  Message.destroy();
                  Message.success(intl.formatMessage({ id: "global.done" }));
                  closeModal && closeModal();

                  setUrlTo(postStepRedirectUrl);
                  actionCallback && actionCallback();
                  setIsOpen(false);
               })
               .catch(() => {
                  Message.error(intl.formatMessage({ id: "messageModal.handleActionError" }));
               })
               .finally(() => setIsExecutingAction(false));
         }
      } else {
         if (!formUuid) return;
         // First we validate if user selected recipient.
         let isError = false;
         sysModalFormRef.validateFields((err) => {
            if (err) isError = true;
         });
         if (isError) return;

         if (!!selectedRecipient) {
            setIsExecutingAction(true);
            formRef?.current
               ?.handleFormSubmit()
               .then(() => {
                  // Here we take values from sys modal (there where we pick next recipient and add comment)
                  let comment = sysModalFormRef.getFieldValue("comment");

                  // Return the promise so the outer .finally() waits for handleSysButton to complete
                  return handleSysButton(
                     sysAction.data.method,
                     sysAction.data.action,
                     Number(sysAction.data.body.messageId),
                     Number(sysAction.data.body.instanceStepId),
                     Number(selectedRecipient),
                     comment,
                  )
                     .then(() => {
                        closeModal && closeModal();
                        setIsOpen(false);
                        setUrlTo(postStepRedirectUrl);
                     })
                     .catch(() => {
                        Message.error(intl.formatMessage({ id: "messageModal.handleActionError" }));
                     })
                     .finally(() => {
                        Message.destroy();
                     });
               })
               .catch((err) => {
                  console.log(JSON.stringify(err));
                  closeModal && closeModal();
                  Message.destroy();
                  Message.error(intl.formatMessage({ id: "form.errorWhileSaving" }));
               })
               .finally(() => setIsExecutingAction(false));
         } else {
            Message.warning(intl.formatMessage({ id: "form.selectRecipient" }));
         }
      }
   };

   const createInifnityActionsList = () => {
      let infinityListItems = [];
      const normalButtons = infinityListActions?.normalButtons?.map((button, index) => ({
         id: button.id,
         name: (
            <SingleButton
               button={button}
               key={index}
               handleNormalAction={handleNormalAction}
               windowWidth={windowWidth}
               instanceId={instanceId}
               recordId={recordId}
               buttonAsLink={buttonAsLink}
               actionId={actionId}
               disabled={isButtonsDisabled}
               showIconWithStyle={false}
               btnClassName={btnClassName}
               plannedDate={plannedDate}
               insideDropdown={true}
               currentProcessStep={currentProcessStep}
               isSingleCaseItem={isSingleCaseItem}
               setIsDropdownOpen={setIsOpen}
               isButtonClickedFromDropdown={true}
               linkToCase={linkToCase}
            />
         ),
         customButton: true,
      }));

      infinityListItems = infinityListItems?.concat(normalButtons);

      let systemButtons = getVisibleSystemButtons({
         systemButtons: infinityListActions?.systemButtons,
         visibilityOptions,
         clientTypeId: currentClientTypeId,
      }).map(({ key, value }, index) => ({
         id: key,
         name: (
            <SingleSysButton
               key={index}
               sysButtonKey={key}
               sysButtonValue={value}
               handleSysAction={handleSysAction}
               windowWidth={windowWidth}
               instanceId={instanceId}
               recordId={recordId}
               isCaseAction={inCaseActions}
               linkToCase={linkToCase}
               setIsDropdownOpen={setIsOpen}
               disabled={isButtonsDisabled}
            />
         ),
         customButton: true,
      }));

      infinityListItems = infinityListItems?.concat(systemButtons);

      return infinityListItems;
   };

   const items = [
      !isQuestionMode && normalButtons
         ? normalButtons?.map((button, index) => ({
              id: button.id,
              name: (
                 <SingleButton
                    button={button}
                    key={index}
                    handleNormalAction={handleNormalAction}
                    windowWidth={windowWidth}
                    instanceId={instanceId}
                    recordId={recordId}
                    buttonAsLink={buttonAsLink}
                    actionId={actionId}
                    disabled={isButtonsDisabled}
                    showIconWithStyle={false}
                    btnClassName={btnClassName}
                    plannedDate={plannedDate}
                    insideDropdown={true}
                    currentProcessStep={currentProcessStep}
                    isSingleCaseItem={isSingleCaseItem}
                    setIsDropdownOpen={setIsOpen}
                    isButtonClickedFromDropdown={false}
                    linkToCase={linkToCase}
                 />
              ),
              customButton: true,
           }))
         : null,
      normalButtons && visibleSystemButtons.length && projectConfig?.isSystemButtonsVisible
         ? {
              id: "divider",
              name: <Divider className="message-buttons-divider" />,
              customButton: true,
           }
         : null,
      projectConfig?.isSystemButtonsVisible && visibleSystemButtons.length
         ? visibleSystemButtons.map(({ key, value }, index) =>
              (key === "moveForward" && !sysBtnsConfig?.hideProcessButtons) ||
              (key === "askQuestion" && !sysBtnsConfig?.hideQuestionButton) ||
              key === "answer"
                 ? {
                      id: key,
                      name: (
                         <SingleSysButton
                            key={index}
                            sysButtonKey={key}
                            sysButtonValue={value}
                            handleSysAction={handleSysAction}
                            windowWidth={windowWidth}
                            instanceId={instanceId}
                            recordId={recordId}
                            isCaseAction={inCaseActions}
                            linkToCase={linkToCase}
                            setIsDropdownOpen={setIsOpen}
                            disabled={isButtonsDisabled}
                         />
                      ),
                      customButton: true,
                   }
                 : null,
           )
         : null,
      !hideChat && !projectConfig?.hideChat && projectConfig?.isChatButtonInSystemButtonsDisplayed
         ? {
              id: "chat-button",
              name: (
                 // @ts-ignore
                 <CreateChatInMessage
                    currentProcessStep={currentProcessStep}
                    windowWidth={windowWidth}
                    customTitle={currentProcessStep?.name || "Chat name"}
                    setIsChatSetModalOpen={setIsOpen}
                 />
              ),
              customButton: true,
           }
         : null,
   ]
      .flat()
      .filter((item) => item !== null);

   const dropdownNoDataInfo = isLoadingActions ? (
      <div className="message-buttons-dropdown__loading-state">
         <Spin size="small" />
      </div>
   ) : undefined;

   //we want this to work like this: we have 1 button from backend? we are showing this button. We have more buttons? we are showing dropdown
   // update: i added "!projectConfig?.isSystemButtonsVisible" becouse for example on tasklytics we can have only one normalButton (Anwser), but we still want to display system buttons

   const handleButtonNormalAction = async (
      event: SyntheticEvent,
      closeModal: () => void,
      isUserNextStepRecipient: boolean,
      button: ActionButton,
   ) => {
      if (formRef?.current?.handleFormSubmit) {
         setTriggerRequiredFieldsModal(false);
         setIsExecutingAction(true);
         try {
            await formRef.current.handleFormSubmit();
         } catch (err) {
            setIsExecutingAction(false);
            if ((err as FormSubmitError)?.type !== FORM_SUBMIT_ERROR.VALIDATION.type) return;
            setPendingAction(() => async () => {
               try {
                  await formRef.current.handleFormSubmit();
               } catch {
                  setTriggerRequiredFieldsModal(true);
                  return;
               }
               setPendingAction(null);
               await handleNormalAction(
                  button,
                  undefined,
                  button.targetStepId,
                  null,
                  closeModal,
                  isUserNextStepRecipient,
               )(event);
            });
            setTriggerRequiredFieldsModal(true);
            return;
         }
      }
      await handleNormalAction(
         button,
         undefined,
         button.targetStepId,
         null,
         closeModal,
         isUserNextStepRecipient,
      )(event);
   };
   const handleCancelModal = () => {
      if (modalStep) {
         setIsFormOpen(modalStep.instanceId, false);
         setIsAnyFieldInFormLoading(false);
         setIsOpen(false);
         setTabsVisibility(new Map());
         setHasRequiredFields(true);
      }
   };

   useEffect(() => {
      if (!allUsersLoaded && !allUsersLoading) {
         dispatch(fetchAllUsersIfNeeded(getUsers));
      }
   }, [allUsersLoaded, allUsersLoading, dispatch]);

   useEffect(() => {
      if (hasRequiredFields) {
         autoTriggerFiredRef.current = false;
         return;
      }
      if (autoTriggerFiredRef.current) return;
      if (!modalStep || modalStep.instanceId !== instanceId) return;
      if (!isFormOpen(modalStep.instanceId)) return;
      if (!actions?.length) return;

      autoTriggerFiredRef.current = true;

      const fakeEvent = { preventDefault: () => {} } as SyntheticEvent;
      const closeModal = () => {
         setIsFormOpen(modalStep.instanceId, false);
         setIsOpen(false);
         setHasRequiredFields(true);
      };

      if (actions[0]?.nextStepRecipientHandlingMode?.toString() === "1") {
         formRef?.current
            ?.handleFormSubmit()
            .then(() => setIsRecipientFormOpen(true))
            .catch((err: FormSubmitError) => {
               if (err?.type === FORM_SUBMIT_ERROR.VALIDATION.type)
                  Message.warning(intl.formatMessage({ id: "form.fillRequiredFields" }));
            });
      } else if (actions.length === 1) {
         handleButtonNormalAction(
            fakeEvent,
            closeModal,
            actions[0]?.isUserNextStepRecipient,
            actions[0],
         );
      }
   }, [hasRequiredFields, modalStep, instanceId, actions]);

   return (
      <>
         {(displayedInInfinityList
            ? createInifnityActionsList()?.length
            : normalButtons?.length) === 1 && !projectConfig?.isSystemButtonsVisible ? (
            <SingleButton
               button={normalButtons?.[0]}
               key={1}
               handleNormalAction={handleNormalAction}
               windowWidth={windowWidth}
               instanceId={instanceId}
               disabled={isButtonsDisabled}
               recordId={recordId}
               buttonAsLink={buttonAsLink}
               actionId={actionId}
               showIconWithStyle={true}
               btnClassName={btnClassName}
               plannedDate={plannedDate}
               insideDropdown={false}
               currentProcessStep={currentProcessStep}
               isSingleCaseItem={isSingleCaseItem}
               setIsDropdownOpen={setIsOpen}
               isButtonClickedFromDropdown={false}
               linkToCase={linkToCase}
            />
         ) : !projectConfig?.areFastActionsEnabled &&
           isSingleCaseItem &&
           !displayedInInfinityList ? (
            <Link to={linkToCase}>
               <Button
                  className={`${btnClassName} message-buttons-dropdown-btn`}
                  buttonType="primary"
               >
                  <span style={{ marginLeft: "15px" }}>
                     <IntlMessages id="message.continue" />
                  </span>
                  <span className="material-symbols-outlined arrow-icon">chevron_right</span>
               </Button>
            </Link>
         ) : (
            <span ref={dropdownTriggerRef} style={{ display: "contents" }}>
               <Button
                  onClick={() => setIsOpen((prev) => !prev)}
                  className={`${btnClassName} message-buttons-dropdown-btn`}
                  disabled={
                     ((!formUuid ||
                        (formInfo[formUuid]?.mainFormRef &&
                           (formInfo[formUuid]?.mainFormRef?.getFieldsValue() === undefined ||
                              JSON.stringify(formInfo[formUuid]?.mainFormRef?.getFieldsValue()) ===
                                 "{}"))) &&
                        !inCaseActions) ||
                     isButtonsDisabled
                  }
                  buttonType="primary"
               >
                  <span style={{ marginLeft: "15px" }}>
                     <IntlMessages id="message.continue" />
                  </span>
                  <span className="material-symbols-outlined arrow-icon">chevron_right</span>

                  <Dropdown
                     className="message-buttons-dropdown"
                     isOpen={isOpen}
                     items={displayedInInfinityList ? createInifnityActionsList() : items}
                     noDataInfo={dropdownNoDataInfo}
                     setIsOpen={setIsOpen}
                     ignoreRef={dropdownTriggerRef}
                     customZIndex={isInNuxtContext() && hideChat ? 51 : undefined}
                  />
               </Button>
            </span>
         )}
         {modalStep && modalStep.instanceId === currentProcessStep?.instanceId && (
            <Modal isOpen={isFormOpen(modalStep?.instanceId)} onCancel={handleCancelModal}>
               {actions && modalStep && (
                  <>
                     {isRecipientFormOpen && actions[0] && (
                        <MessageModal
                           action={actions[0]}
                           handleNormalAction={handleNormalAction}
                           closeModal={() => setIsOpen(false)}
                           instanceId={instanceId}
                           recordId={recordId}
                           linkToCase={isSingleCaseItem ? linkToCase : null}
                        />
                     )}

                     <div
                        style={{
                           visibility: isRecipientFormOpen ? "hidden" : "visible",
                           height: isRecipientFormOpen ? 0 : "auto",
                           overflow: "hidden",
                           pointerEvents: isRecipientFormOpen ? "none" : "auto",
                        }}
                     >
                        <FormComplete
                           key={`${modalStep.formId}-${modalStep.dataId}`}
                           isMessageForm
                           formId={modalStep.formId}
                           dataId={modalStep.dataId}
                           isSubmitVisible={false}
                           initialData={modalStep.initialData}
                           areOnlyRequiredFieldsVisible
                           formRef={formRef}
                        />

                        <div className="fast-action-buttons">
                           {modalStep?.configuration?.step?.showSaveForm && (
                              <Button
                                 onClick={() => formRef?.current?.handleFormSubmit()}
                                 disabled={isFormLoading}
                              >
                                 {intl.formatMessage({ id: "global.save" })}
                              </Button>
                           )}
                           <div className="fast-action-buttons__actions">
                              {actions[0]?.nextStepRecipientHandlingMode.toString() === "1" ? (
                                 <Button
                                    buttonType="primary"
                                    onClick={async () => {
                                       await formRef?.current?.handleFormSubmit();
                                       setIsRecipientFormOpen(true);
                                    }}
                                    disabled={
                                       checkIfDisabled(actions[0], recordId) || isExecutingAction
                                    }
                                 >
                                    {actions[0]?.label}
                                 </Button>
                              ) : (
                                 actions.map((btn) => (
                                    <Button
                                       key={btn.label}
                                       buttonType="primary"
                                       onClick={(event) => {
                                          handleButtonNormalAction(
                                             event,
                                             () => {
                                                setIsFormOpen(modalStep.instanceId, false);
                                                setIsOpen(false);
                                             },
                                             btn?.isUserNextStepRecipient,
                                             btn,
                                          );
                                       }}
                                       disabled={
                                          checkIfDisabled(btn, recordId) ||
                                          isFormLoading ||
                                          isExecutingAction
                                       }
                                    >
                                       {btn.label?.trim()?.length ? (
                                          btn.label
                                       ) : (
                                          <IntlMessages id="global.save" />
                                       )}
                                    </Button>
                                 ))
                              )}
                           </div>

                           <LinkToCase
                              linkToCase={linkToCase}
                              onClick={() => setIsFormOpen(modalStep.instanceId, false)}
                           />
                        </div>
                     </div>
                  </>
               )}
            </Modal>
         )}
      </>
   );
};

export default MessageButtonsDropdown;
